import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../contexts/I18nContext';
import { useNavigate } from 'react-router-dom';
import { LogOut, Settings } from 'lucide-react';
import ProfileAvatar from '../ProfileAvatar';

export const UserMenu: React.FC = () => {
  const { member, logout, memberstack } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [selectedAvatar, setSelectedAvatar] = useState<'male' | 'female' | 'neutral'>('neutral');

  // Load avatar preference from user data
  useEffect(() => {
    const loadAvatarPreference = async () => {
      if (memberstack) {
        try {
          const response = await memberstack.getMemberJSON();
          const userData = response.data || {};
          if (userData.avatarType && ['male', 'female', 'neutral'].includes(userData.avatarType)) {
            setSelectedAvatar(userData.avatarType);
          }
        } catch (error) {
          console.error('Failed to load avatar preference:', error);
        }
      }
    };
    loadAvatarPreference();
  }, [memberstack]);

  if (!member) return null;

  console.log(member);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative rounded-full p-0">
          <ProfileAvatar avatarType={selectedAvatar} size="md" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">
              { /* member.auth.name || TODO: Not working */ t('nav.profile')}
            </p>
            <p className="text-xs leading-none text-muted-foreground">
              {member.auth.email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/settings')}>
          <Settings className="mr-2 h-4 w-4" />
          <span>{t('nav.settings')}</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>{t('nav.logout')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
